import { Box, Text, Table, Thead, Tbody, Tr, Th, Td, Spinner, Flex } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import TrackingPageLayout from "components/TrackingPageLayout";
import { useTripPositions } from "hooks/useTrackingTrips";

function formatDate(dateString: string) {
  return new Date(dateString).toLocaleString("fr-FR");
}

export default function TrackingTripHistoryPage() {
  const { tripId } = useParams();
  const { positions, isLoading, error } = useTripPositions(tripId || null);

  return (
    <TrackingPageLayout title={`Historique des positions${tripId ? ` – Trajet ${tripId.slice(0, 8)}…` : ""}`}>
      {error && (
        <Text color="red.600" mb={4} px={4} pt={4}>
          Erreur lors du chargement des positions.
        </Text>
      )}
      {isLoading && (positions?.length ?? 0) === 0 ? (
        <Flex justify="center" py={8}><Spinner size="lg" /></Flex>
      ) : (positions?.length ?? 0) === 0 ? (
        <Box p={8} textAlign="center"><Text color="gray.600">Aucune position enregistrée pour ce trajet.</Text></Box>
      ) : (
        <Box overflowX="auto" px={4} pb={4}>
          <Table size="sm">
            <Thead>
              <Tr>
                <Th>Latitude</Th>
                <Th>Longitude</Th>
                <Th>Date / heure</Th>
              </Tr>
            </Thead>
            <Tbody>
              {positions.map((pos) => (
                <Tr key={pos.id}>
                  <Td>{Number(pos.latitude).toFixed(6)}</Td>
                  <Td>{Number(pos.longitude).toFixed(6)}</Td>
                  <Td>{formatDate(pos.recorded_at || pos.timestamp || "")}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      )}
    </TrackingPageLayout>
  );
}

